import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { isNullOrUndefined } from '@app/shared/helpers';
import { SharedForm } from '@models/forms/shared-form';
import { FormType, formTypeNames } from '@models/forms/form-type.enum';
import { SharedFormService } from '@services/shared-form.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-shared-form-edit',
  templateUrl: './shared-form-edit.component.html',
  styleUrls: ['./shared-form-edit.component.less'],
})
export class SharedFormEditComponent implements OnInit, OnDestroy {
  loading = false;
  disableGrid = true;
  unsub: Subject<void> = new Subject<void>();
  formId: number;

  form: FormGroup;
  addOrUpdate: string;

  FormType = FormType;
  formTypeNames = formTypeNames;

  constructor(
    private fb: FormBuilder,
    private sharedFormService: SharedFormService,
    private route: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit() {
    this.route.params.pipe(takeUntil(this.unsub)).subscribe((params) => {
      this.formId = +params['id'];
      this.addOrUpdate = 'Update';

      this.initForm();

      this.sharedFormService.getSharedFormById(this.formId).subscribe((form) => {
        if (!isNullOrUndefined(form)) {
          this.setFormValues(form);
        }
      });
    });
  }

  private initForm() {
    this.form = this.fb.group({
      id: new FormControl(this.formId, [Validators.required]),
      formType: new FormControl(null, [Validators.required]),
      name: new FormControl('', [Validators.required]),
      notes: new FormControl(''),
      formDefinition: new FormControl(''),
    });
  }

  private setFormValues(form: SharedForm) {
    this.form.controls['id'].setValue(form.id);
    this.form.controls['formType'].setValue(form.formType);
    this.form.controls['name'].setValue(form.name);
    this.form.controls['notes'].setValue(form.notes);
    this.form.controls['formDefinition'].setValue(form.formDefinition);
  }

  isFormDisabled(): boolean {
    return !this.form.valid;
  }

  onSubmit() {
    this.loading = true;

    try {
      this.sharedFormService.updateSharedForm(this.form.value).subscribe(() => {
        this.router.navigate(['/management/forms', { outlets: { 'action-panel': null } }]);
      });
    } catch {
      this.loading = false;
    }
  }

  cancelUpdate() {
    this.router.navigate(['/management/forms', { outlets: { 'action-panel': null } }]);
  }

  ngOnDestroy() {
    this.unsub.next();
    this.unsub.complete();
  }
}

